module.exports = __webpack_public_path__ + "img/section4_img1.5a4be6e7.svg";